export enum EmailReportRole {
  PROJECT_MANAGER = 1,
  DEPARTMENT_MANAGER = 2,
  MANAGING_DIRECTOR = 3,
}
